import { getAvailableMeterYears, getAvailableMeterYearsByCompany } from '@shared/domain/meters/service/meter.service'
import type { AvailableMeterYears } from '@shared/domain/meters/types/available-meter-years.type'
import create from 'zustand'

interface MeterStore {
  availableYears: AvailableMeterYears | undefined
  isCurrentYearAvailable: boolean
}

interface MeterStoreActions {
  getAvailableYears: (locationId: number) => void
  getAvailableYearsByCompany: (companyId: string) => void
  clearAvailableYears: () => void
}

export const useMeterStore = create<MeterStore & MeterStoreActions>(set => ({
  availableYears: undefined,
  isCurrentYearAvailable: false,

  // store actions
  getAvailableYears: (locationId: number) => {
    getAvailableMeterYears({ locationId }).then(res => {
      const years = res.data as unknown as AvailableMeterYears
      const currentYear = new Date().getFullYear()
      set(state => ({
        ...state,
        availableYears: years,
        isCurrentYearAvailable: years.availableYears.includes(currentYear),
      }))
    })
  },
  getAvailableYearsByCompany: (companyId: string) => {
    getAvailableMeterYearsByCompany({ companyId }).then(res => {
      const years = res.data as unknown as AvailableMeterYears
      const currentYear = new Date().getFullYear()
      set(state => ({
        ...state,
        availableYears: years,
        isCurrentYearAvailable: years.availableYears.includes(currentYear),
      }))
    })
  },
  clearAvailableYears: () => {
    set(state => ({
      ...state,
      availableYears: undefined,
    }))
  },
}))
